<template>
    <div>
        <items-list></items-list>
    </div>
</template>

<script>
    import ItemsList from '../components/ItemsList'
    export default {
        name: "Items",
        components:{
            ItemsList
        }
    }
</script>

<style scoped>

</style>